import styled from "styled-components";
import { TextRegular } from "../../styles/GlobalStyledComponents";

export const EndContainer = styled.div`
    gap: 10px;
`;

export const EndImage = styled.img`
    /* margin-bottom: 15px; */
    margin: 5px 0 30px;
`;

export const EndText = styled(TextRegular)`
    padding: 8px 0;
`;